import { createModal } from './create-modal'

export const showErrors = async (context: Word.RequestContext, window, messages: Array<string>): Promise<{
    command: (type: string, message: any) => void
    modalWindow: Office.Dialog
}> => {
    console.log('opening error modal')
    const {command, modalWindow} = await createModal(context, window, {
        url: 'error.html',
        size: [30, 30],
        handler: (command, modalWindow, message) => {
            if (message.type == 'initedErrorModal') {
                command('onPluginErrorMessage', {messages})
            }
        },
    })
    return {
        modalWindow,
        command,
    }
}
